import classNames from "classnames";
import { FunctionComponent, ReactElement } from "react";

import InputWrapper from "rivals/components/shared/Form/Input";
import { setData } from "rivals/shared/utils/qa";
import styles from "./TextInput.module.scss";
import { OwnProps } from "./types";

const TextInput: FunctionComponent<OwnProps> = ({
  autofocus,
  className,
  data = "",
  defaultValue,
  disabled = false,
  id,
  feedback = "",
  hint = "",
  htmlFor = "",
  infoPrompt = "",
  maxLength,
  type,
  label = "",
  onBlur,
  onFocus,
  onChange,
  onKeyDown,
  placeholder = "",
  readOnly = false,
  required = false,
  value
}): ReactElement => {
  const inputClasses = classNames(styles.input, {
    [styles.hint]: hint,
    [styles.infoPrompt]: infoPrompt,
    [styles.feedback]: feedback,
    [styles.inputPassword]: type === "password"
  });

  return (
    <InputWrapper
      className={className}
      data={data}
      feedback={feedback}
      hint={hint}
      htmlFor={htmlFor}
      infoPrompt={infoPrompt}
      label={label}
    >
      <input
        autoFocus={autofocus}
        className={inputClasses}
        defaultValue={defaultValue}
        disabled={disabled}
        id={id}
        maxLength={maxLength}
        name={htmlFor}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        type={type}
        value={value}
        {...setData(data, "input")}
      />
    </InputWrapper>
  );
};

export default TextInput;
